import React from 'react';
import sharpBeam from './lighting-styles/sharp-beam.webp';
import squareReflection from './lighting-styles/square-reflection.webp';
import diffused from './lighting-styles/diffused.webp';
import curtainLines from './lighting-styles/curtain-lines.webp';
import ambient from './lighting-styles/ambient.webp';

/**
 * Lighting-style thumbnails — Flux-generated photos of the SAME light-grey cube
 * in the SAME empty sunlit room (same seed + prompt, only the light clause
 * changes), so all five read as "the same room, different sunlight". Bundled as
 * tiny 4:3 WebP tiles. Used by the Sunlit-empty-room preset's Lighting style.
 */

const LIGHTING_STYLE_IMAGES: Record<string, string> = {
    'sharp-beam': sharpBeam,
    'square-reflection': squareReflection,
    'diffused': diffused,
    'curtain-lines': curtainLines,
    'ambient': ambient,
};

const baseStyle: React.CSSProperties = {
    width: '100%',
    aspectRatio: '4/3',
    display: 'block',
    borderRadius: 6,
};

const makeLightingStyle = (src: string): React.FC => () => (
    <div
        style={{
            ...baseStyle,
            backgroundImage: `url(${src})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            border: '1px solid rgba(0,0,0,0.08)',
        }}
    />
);

export const LIGHTING_STYLE_ILLUSTRATIONS: Record<string, React.FC> = Object.fromEntries(
    Object.entries(LIGHTING_STYLE_IMAGES).map(([slug, src]) => [slug, makeLightingStyle(src)]),
);
